import React, { useState } from 'react';
import { Upload, Button } from 'antd';
import { UploadChangeParam } from 'antd/lib/upload/interface';
import {
  DeleteOutlined,
  FileAddOutlined,
  LoadingOutlined,
  FilePdfOutlined,
} from '@ant-design/icons';
import {
  deleteSingleFile,
  uploadSinglePdfFile,
} from 'modules/galleryModules/requests/galleryRequests';
import uploadFileOptions from 'modules/layoutModule/helpers/uploadFileOptions';
import staticUrl from 'helpers/staticUrl';

export interface IFormFileUploadPropTypes {
  file: string | null;
  setFile: (arg0: any) => void;
  field: string;
  id?: string;
  number?: number;
  isNew?: boolean;
}

const FormFileUpload: React.FC<IFormFileUploadPropTypes> = ({
  file,
  setFile,
  field,
  id,
  isNew,
}): JSX.Element => {
  const [previewLoading, toggleLoading] = useState(false);

  const handleChangeImage = (fileId: UploadChangeParam) => {
    toggleLoading(true);
    if (fileId && fileId.file.status === 'removed') {
      setFile(null);
    }
  };

  const customRequest = (option: { file: string | Blob }) => {
    const formData = new FormData();
    formData.append('pdf', option.file);

    uploadSinglePdfFile(formData).then((response) => {
      if (response) {
        const { data } = response;
        setFile(data.name);
        toggleLoading(false);
      }
    });
  };

  const deleteCover = () =>
    deleteSingleFile({
      file,
      id,
      field,
    }).then(() => {
      setFile(null);
      toggleLoading(false);
    });

  if (file) {
    const fileUrl = () => {
      if (!file) {
        return 'error';
      }
      if (file.includes('upload/')) {
        return file;
      }
      return `${staticUrl()}${isNew ? 'upload/' : ''}${file}.pdf`;
    };

    return (
      <div className="image-upload-row">
        <div>
          <Button
            icon={<DeleteOutlined />}
            onClick={deleteCover}
            className="image-preview-button"
          >
            Usuń plik
          </Button>
          <div className="file-preview">
            <a href={fileUrl()} target="_blank" rel="noreferrer">
              <FilePdfOutlined style={{ fontSize: 30 }} />
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Upload
        {...uploadFileOptions}
        listType="picture-card"
        showUploadList={false}
        onChange={handleChangeImage}
        customRequest={customRequest}
        disabled={previewLoading}
      >
        {previewLoading ? (
          <LoadingOutlined style={{ fontSize: 30 }} />
        ) : (
          <FileAddOutlined style={{ fontSize: 30 }} />
        )}
      </Upload>
    </>
  );
};

export default FormFileUpload;
